import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import './styles/tailwind.css';
import { initReporting } from './lib/reporting.js';
import { Providers } from './app/Providers.jsx';
import { ErrorBoundary } from './app/ErrorBoundary.jsx';
import { router } from './app/router.jsx';

/**
 * Boot order: error reporting first so a failure in the next two lines is still
 * captured, then the providers, then the router.
 */
initReporting();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </ErrorBoundary>
  </StrictMode>,
);
